<template>
  <div>
    <div class="mt-3 mb-5 underline">
      1 약관동의
      <mdb-icon  icon="chevron-right" class="mx-4" />
      2 본인 인증
      <mdb-icon  icon="chevron-right" class="mx-4" />
      3 회원 정보
      <mdb-icon  icon="chevron-right" class="mx-4" />
      <span class=" page-title">4 가입 완료</span>
    </div>
    <div class="text-center">
      <div class="sub-title my-5"><mdb-icon  icon="glass-cheers" /> 축하합니다. 가입이 완료되었습니다.</div>
      <div class="">
        <mdb-btn icon="sign-in-alt" class="my-5" @click="onMoveLogin">로그인</mdb-btn>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
  name: 'JoinComplete',
  data: () => ({
  }),
  computed: mapState({
  }),
  methods: {
    onMoveLogin () {
      this.$router.push({ name: 'Login' })
    }
  }
}
</script>
